import React, { useState, useEffect } from "react";
import { Link, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../CSS/nav.css";
import logo2 from "../Z-IMAGE/Nystai cn logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleUser, faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import Formcn from "../A-LAYOUT/form";
import "bootstrap/dist/css/bootstrap.min.css";
import i18next from "../../i18n";

const Layoutchinna = () => {
  const { t, i18n } = useTranslation();

  const [isOpen2, setIsOpen2] = useState(false);
  const [logo] = useState(logo2);
  const [navbarHeight, setNavbarHeight] = useState(90);
  const [language, setLanguage] = useState("jp");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleOverlay2 = () => {
    setIsOpen2((prev) => !prev);
  };

  useEffect(() => {
    localStorage.removeItem("i18nextLng"); // ← add this line
    const savedLanguage = sessionStorage.getItem("i18nextLng");

    if (!savedLanguage) {
      // New session — always default to Chinese
      i18next.changeLanguage("jp");
      sessionStorage.setItem("i18nextLng", "jp");
      setLanguage("jp");
    } else {
      // Same session — respect user's choice
      i18next.changeLanguage(savedLanguage);
      setLanguage(savedLanguage);
    }
  }, []);

  return (
    <>
      {/* Navbar */}
      <div className="nav-cn-bg-main">
        <div
          id="navbar"
          className="navbar-cn-bg-main"
          style={{
            height: `${navbarHeight}px`,
            transition: "all 0.3s ease",
          }}
        >
          <ul className="navbar-cn-bg-main-ul">
            <li className="menu-nav-cn n">
              <OverlayNav />
            </li>

            <li>
              <Link to="/landing">
                <img src={logo} alt="Logo" className="navbar-logo " />
              </Link>
            </li>

            <li
              className="d-flex align-items-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="language-toggle ms-3 d-flex gap-2">
                <button
                  onClick={() => {
                    i18n.changeLanguage("jp");
                    sessionStorage.setItem("i18nextLng", "jp"); // ← sessionStorage
                    setLanguage("jp");
                  }}
                  className={`btn ${
                    language === "jp" ? "btn-light" : "btn-light"
                  }`}
                >
                  中国人
                </button>

                <button
                  onClick={() => {
                    i18n.changeLanguage("en");
                    sessionStorage.setItem("i18nextLng", "en"); // ← sessionStorage
                    setLanguage("en");
                  }}
                  className={`btn ${
                    language === "en" ? "btn-light" : "btn-light"
                  }`}
                >
                  EN
                </button>
              </div>
              {/* <span  style={{ cursor: "pointer" }}>
                <h5 className="mb-0">
                  <FontAwesomeIcon icon={faCircleUser} className="me-2 ms-3" />
                  {t("contact")}
                </h5>
              </span> */}
            </li>
          </ul>
        </div>
      </div>

      {/* Contact Overlay */}
      <div>
        <div
          id="myNav"
          className="overlay"
          style={{ height: isOpen2 ? "100%" : "0%", cursor: "pointer" }}
        >
          <div className="over-header">
            <a className="closebtn" onClick={toggleOverlay2}>
              <FontAwesomeIcon icon={faCircleXmark} />
            </a>
          </div>
          <div className="overlay-content">
            <Formcn />
          </div>
        </div>
      </div>

      <Outlet />
    </>
  );
};

export default Layoutchinna;

function OverlayNav() {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <div className={`overlay-menu ${isOpen ? "overlay-open-menu" : ""}`}>
        <p
          className="closebtn-menu"
          onClick={() => setIsOpen(false)}
          style={{ cursor: "pointer" }}
        >
          &times;
        </p>

        <div className="overlay-content-menu">
          <div>
            <p>
              <Link
                to="/scmpage"
                style={{
                  color: "white",
                  textDecoration: "none",
                }}
                onClick={() => setIsOpen(false)}
              >
                {t("supplyChainManagement")}
              </Link>
            </p>

            <p>
              <Link
                to="/techpage"
                style={{
                  color: "white",
                  textDecoration: "none",
                }}
                onClick={() => setIsOpen(false)}
              >
                {t("technologies")}
              </Link>
            </p>
          </div>
        </div>
      </div>

      <h5
        style={{ cursor: "pointer", marginBottom: 0 }}
        onClick={() => setIsOpen(true)}
      >
        &#9776; {t("menu")}
      </h5>
    </div>
  );
}
